module.exports = function() {
  return new Worker(__webpack_public_path__ + "b6959098d798174bd69f.worker.js");
};